import Icon from '@/components/ui/icons/Icon';
import { getActiveLocale } from '@/utils/active-locale';
import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const BackButton = ({ setActiveSidebarSubNav }: { setActiveSidebarSubNav: React.Dispatch<React.SetStateAction<any>> }) => {
  const label = getActiveLocale() === 'en' ? 'Back' : 'Terug';

  return (
    <button onClick={() => setActiveSidebarSubNav(null)} className='flex items-center gap-x-1.5 mb-6 px-3 text-sm text-white'>
      <span>
        <Icon name='arrow-right' className='w-4 h-4 mr-1 rotate-180' />
      </span>
      {label}
    </button>
  );
};
 